import React from 'react';
import { Wrapper, Heading, Content, TopIcon, Tnc } from './styles';

const Popup1 = () => (
  <Wrapper>
    <TopIcon>
      <img src={`${process.env.REACT_APP_BUILD_URL}/images/site/home/icon5.png`} alt="" width="100" />
    </TopIcon>
    <Heading>最大 24 bit FLAC 歌庫</Heading>
    <br />
    <hr />
    <Content>
    MOOV提供超過20,000首 24 bit 歌曲，擁有最大的 24 bit FLAC 無損串流廣東歌庫<sup>#</sup> ，同時亦收藏國語、歐美、KPOP、古典等大量新舊經典。完美 24 bit 歌曲，完全無限聽，提供一個真正屬於香港人的音樂串流服務。
    <br />
    <br />
    <Tnc>#根據MOOV針對在香港營運之8大音樂串流平台之內部調查。截至2020年3月16日，MOOV擁有香港最大 24 bit FLAC 無損串流音樂庫提供 24 bit FLAC 無損音樂庫及音源資訊包括位元度、取樣頻率、音頻格式、版本及位元率之音樂串流平台。</Tnc>
    </Content>
  </Wrapper>
)

export default Popup1;